module.exports = __webpack_public_path__ + "img/re-open-job.6392b78a.svg";